module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.watchlist', {
            url: '/favourites',
            resolve: {
                modules: [
                    '$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load('lists');
                    }
                ]
            },
            views: {
                'center-panel@': {
                    template: '<bws-watch-list-products></bws-watch-list-products>'
                }
            },
            data: {
                analytics: 'bws:web:favourites',
                authenticate: true,
                pageMetadata: {
                    title: 'Watchlist',
                    metaDescription: 'Watchlist - BWS',
                    metaRobot: 'noindex, nofollow'
                }
            }
        })
        .state('shop.list.edit.freetext', {
            url: '/products?searchTerm',
            data: {
                analytics: 'bws:web:products'
            },
            resolve: {
                init: [
                    'SavedListsService', function (savedListService) {
                        savedListService.freeTextProducts = true;
                    }
                ]
            },
            views: {
                'center-panel@': {
                    template: '<wow-card-list><wow-search-list is-list="true"></wow-search-list></wow-card-list>'
                }
            }
        });
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/lists.js
 **/